import type { CreateOnKeyDown } from '../../types/plugin';
import type { ListPluginPropertyOptions } from './types';
import { isNodeTypeIn } from '../../utils/isNodeTypeIn';
import { Node, Range } from '../../core';

import isHotkey from 'is-hotkey';
import {
  findClosestBlockPathAtSelection,
  getDecreaseIndentHotkey,
  getIncreaseIndentHotkey,
  isListItemEmpty,
  getBulletedListHotkey,
  getNumberedListHotkey,
  getCurrentActiveListVariant,
} from './utils';
import { LIST_VARIANTS } from './constants';
import { insertParagraph } from '../paragraph/utils';
import { increaseIndent, decreaseIndent } from './functions';
import { toggleList } from './toggleFunctions';

export const onKeyDownLists: CreateOnKeyDown<ListPluginPropertyOptions> =
  ({ pluginID, sendModifyDictationMessageRef }) =>
  (e: KeyboardEvent, { editor }) => {
    const sendModifyDictationMessage = () => sendModifyDictationMessageRef?.current?.();
    const variant = getCurrentActiveListVariant(editor);
    const path = findClosestBlockPathAtSelection(editor);
    const node = Node.get(editor, path);

    if (isHotkey('enter', e) && isNodeTypeIn(editor, pluginID)) {
      if (isListItemEmpty(node)) {
        e.preventDefault();
        sendModifyDictationMessage();
        ``;
        decreaseIndent(editor, variant);

        return true;
      }
    }

    if (isHotkey('shift+enter', e) && isNodeTypeIn(editor, pluginID)) {
      // only catering for collapsed selection to minimize edge cases
      if (variant != null && editor.selection && Range.isCollapsed(editor.selection)) {
        e.preventDefault();
        sendModifyDictationMessage();

        insertParagraph(editor);

        return true;
      }
    }

    if (isHotkey(getIncreaseIndentHotkey(), e)) {
      e.preventDefault();
      if (isNodeTypeIn(editor, pluginID)) {
        sendModifyDictationMessage();
        increaseIndent(editor, variant);
        return true;
      }
    }

    if (isHotkey(getDecreaseIndentHotkey(), e)) {
      e.preventDefault();
      if (isNodeTypeIn(editor, pluginID)) {
        sendModifyDictationMessage();
        decreaseIndent(editor, variant);
        return true;
      }
    }

    if (isHotkey(getBulletedListHotkey(), e)) {
      e.preventDefault();
      sendModifyDictationMessage();
      toggleList(editor, variant, LIST_VARIANTS.ul);
      return true;
    }

    if (isHotkey(getNumberedListHotkey(), e)) {
      e.preventDefault();
      sendModifyDictationMessage();
      toggleList(editor, variant, LIST_VARIANTS.ol);
      return true;
    }

    return undefined;
  };
